import React, { useState } from 'react';
import HistorialService from '../services/historiales';
import { notificationSystem } from '../utils/notifications';

function NotasSesion({ notas, paciente_id, onRefresh }) {
  const [mostrarFormulario, setMostrarFormulario] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    numero_sesion: '',
    fecha_sesion: new Date().toISOString().split('T')[0],
    duracion_minutos: 60,
    terapeuta: '',
    resumen_sesion: '',
    temas_tratados: '',
    tareas_asignadas: '',
    observaciones: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({...prev, [name]: value}));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      await HistorialService.agregarNotaSesion(paciente_id, formData);
      notificationSystem.success('Nota de sesión registrada');
      setMostrarFormulario(false);
      setFormData({
        numero_sesion: '',
        fecha_sesion: new Date().toISOString().split('T')[0],
        duracion_minutos: 60,
        terapeuta: '',
        resumen_sesion: '',
        temas_tratados: '',
        tareas_asignadas: '',
        observaciones: ''
      });
      onRefresh();
    } catch (error) {
      console.error('Error:', error);
      notificationSystem.error('Error al guardar nota de sesión');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="notas-sesion">
      <button 
        className="btn-agregar" 
        onClick={() => setMostrarFormulario(!mostrarFormulario)}
      >
        + Agregar Nota de Sesión
      </button>

      {mostrarFormulario && (
        <form onSubmit={handleSubmit} className="formulario">
          <div className="form-row">
            <div>
              <label>Número de Sesión *</label>
              <input 
                type="number" 
                name="numero_sesion"
                placeholder="Ej: 1"
                value={formData.numero_sesion}
                onChange={handleChange}
                required
              />
            </div>
            <div>
              <label>Fecha de Sesión *</label>
              <input 
                type="date" 
                name="fecha_sesion"
                value={formData.fecha_sesion}
                onChange={handleChange}
                required
              />
            </div>
            <div>
              <label>Duración (minutos)</label>
              <input 
                type="number" 
                name="duracion_minutos"
                value={formData.duracion_minutos}
                onChange={handleChange}
              />
            </div>
          </div>

          <div>
            <label>Terapeuta</label>
            <input 
              type="text" 
              name="terapeuta"
              placeholder="Nombre del terapeuta"
              value={formData.terapeuta}
              onChange={handleChange}
            />
          </div>

          <div>
            <label>Resumen de la Sesión</label>
            <textarea 
              name="resumen_sesion"
              placeholder="Resumen general de lo tratado"
              value={formData.resumen_sesion}
              onChange={handleChange}
              rows="4"
            />
          </div>

          <div>
            <label>Temas Tratados</label>
            <textarea 
              name="temas_tratados"
              placeholder="Temas principales abordados"
              value={formData.temas_tratados}
              onChange={handleChange}
              rows="3"
            />
          </div>

          <div>
            <label>Tareas Asignadas</label>
            <textarea 
              name="tareas_asignadas"
              placeholder="Tareas para realizar entre sesiones"
              value={formData.tareas_asignadas}
              onChange={handleChange}
              rows="3"
            />
          </div>

          <div>
            <label>Observaciones</label>
            <textarea 
              name="observaciones"
              placeholder="Observaciones adicionales"
              value={formData.observaciones}
              onChange={handleChange}
              rows="3"
            />
          </div>

          <div className="form-buttons">
            <button type="submit" className="btn-guardar" disabled={loading}>
              {loading ? 'Guardando...' : 'Guardar Nota'}
            </button>
            <button 
              type="button" 
              className="btn-cancelar" 
              onClick={() => setMostrarFormulario(false)}
              disabled={loading}
            >
              Cancelar
            </button>
          </div>
        </form>
      )}

      <div className="notas-lista">
        {notas.length === 0 ? (
          <p className="no-data">No hay notas registradas</p>
        ) : (
          notas.map((nota) => (
            <div key={nota.id} className="nota-card">
              <div className="nota-header">
                <div>
                  <h4>Sesión #{nota.numero_sesion}</h4>
                  <small>{new Date(nota.fecha_sesion).toLocaleDateString()}</small>
                </div>
                {nota.duracion_minutos && <span className="duracion">{nota.duracion_minutos} min</span>}
              </div>
              {nota.terapeuta && <p><strong>Terapeuta:</strong> {nota.terapeuta}</p>}
              {nota.resumen_sesion && <div className="info-section"><strong>Resumen:</strong><p>{nota.resumen_sesion}</p></div>}
              {nota.temas_tratados && <div className="info-section"><strong>Temas:</strong><p>{nota.temas_tratados}</p></div>}
              {nota.tareas_asignadas && <div className="info-section"><strong>Tareas:</strong><p>{nota.tareas_asignadas}</p></div>}
              {nota.observaciones && <div className="info-section"><strong>Observaciones:</strong><p>{nota.observaciones}</p></div>}
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default NotasSesion;
